import React from "react";
import transactions from "@/assets/SVG/Transactions.svg";
import transactions_bitramp from "../assets/SVG/Transactions_Bitramp.svg";
import exchange from "@/assets/SVG/exchange.svg";
import exchange_bitramp from "../assets/SVG/Exchange_Bitramp.svg";
import settings from "@/assets/SVG/settings.svg";
import settings_bitramp from "../assets/SVG/Setting_Bitramp.svg";
import { InboxType } from "@/types/Inbox";
import GenericApi from "@/api/genericApi";
import { ApiRoutes } from "@/config/routes/ApiRoutes";
import { ApiResponse, ApiError } from "@/types/Api";
import { Transaction } from "@/types/Transaction";
import { ValidationErrors } from "@/types/ValidationError";
import CustomLogger from "@/utils/CustomLogger";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  InboxQueryKey,
  InboxUnreadQueryKey,
} from "@/config/constants/QueryKeys";
import { useAppDispatch } from "@/store";
import { setActiveComponent } from "@/store/slices/componentSlice";
import { setInboxTransaction, setInboxUser } from "@/store/slices/inboxSlice";
import { isBitramp } from "@/utils/utils";

interface InboxNotificationProps {
  photo: string;
  message: string;
  time: string;
  id: number;
  seen: boolean;
  inboxUser: number | null;
  inboxTransaction: string | null;
}

const InboxNotification: React.FC<InboxNotificationProps> = ({
  id,
  photo,
  message,
  time,
  seen,
  inboxUser,
  inboxTransaction,
}) => {
  const queryClient = useQueryClient();

  const readNotificationMutation = useMutation<
    ApiResponse<unknown>,
    ApiError<ValidationErrors>,
    unknown
  >({
    mutationFn: () =>
      GenericApi.post<Transaction>(`${ApiRoutes.INBOX}/read/${id}`, {}),
    onSuccess: async ({ data }) => {
      CustomLogger.log(data);
      queryClient.invalidateQueries({ queryKey: [InboxQueryKey] });
      queryClient.invalidateQueries({ queryKey: [InboxUnreadQueryKey] });
    },
    onError: async ({ error }) => {
      CustomLogger.error(error);
    },
  });

  const getNameByInboxType = (type: string) => {
    switch (type) {
      case InboxType.Transaction:
        return "Transaction";
      case InboxType.Exchange:
        return "Exchange";
      case InboxType.Setting:
        return "Setting";
      default:
        return "Unknown";
    }
  };

  const name = getNameByInboxType(photo);
  const dispatch = useAppDispatch();

  const handleNotificationClick = () => {
    if (!seen) readNotificationMutation.mutate({});
    if (name == "Transaction") dispatch(setActiveComponent("Transactions"));
    dispatch(setInboxUser(inboxUser));
    dispatch(setInboxTransaction(inboxTransaction));
  };

  return (
    <div
      onClick={() => {
        handleNotificationClick();
      }}
      className={`w-full cursor-pointer px-6 py-[1rem] flex items-center justify-between rounded-[9px] ${
        seen
          ? isBitramp()
            ? "bg-[#2B2B2B]"
            : "bg-[#F4F4F4]"
          : isBitramp()
          ? "bg-[#464646] border-l-[0.5rem] border-l-[red]"
          : "border border-[#DBDBDB] border-l-[0.5rem] border-l-[red]"
      }`}
    >
      <div
        className={`w-[25%] flex items-center gap-4 ${
          seen ? (isBitramp() ? "ml-[0.5rem]" : "ml-[0.5rem]") : (isBitramp() ? "ml-[0rem]" : "ml-[0rem]")
        }`}
      >
        <img
          // src={
          //   photo === InboxType.Transaction
          //     ? transactions
          //     : photo === InboxType.Exchange
          //     ? exchange
          //     : settings
          // }
          src={
            isBitramp()
              ? photo === InboxType.Transaction
                ? transactions_bitramp
                : photo === InboxType.Exchange
                ? exchange_bitramp
                : settings_bitramp
              : photo === InboxType.Transaction
              ? transactions
              : photo === InboxType.Exchange
              ? exchange
              : settings
          }
        />
        <div className="Text dark-blue semi-bold">{name}</div>
      </div>

      <div
        className={`w-[80%] flex justify-start Text  ${
          seen ? "text-[#6d6d6d]" : (isBitramp() ? "text-[#9F9F9F]" : "dark-blue")
        }`}
      >
        {message}
      </div>
      <div className="w-[10%] Text text-[#6d6d6d] text-right">{time}</div>
    </div>
  );
};

export default InboxNotification;
